"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _admin = require("@/store/modules/admin");
var _admins = require("@/api/admins");
var _leads = require("@/api/leads");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.loggedInUser = null;
    this.coordinatorList = [];
    this.categorizationList = ['A+ Inquiry', 'A Inquiry', 'B Inquiry', 'C Inquiry', 'D Inquiry'];
  }
  created() {
    this.loggedInUser = _admin.AdminModule;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.fetchCoordinatorList();
      this.fetchData();
    }
  }
  async fetchData() {
    const response = await (0, _leads.getInquiryValue)((0, _index.getQuery)({
      startDate: this.startDate,
      endDate: this.endDate
    }));
    const result = [];
    const groupedData = {};
    response.forEach(item => {
      const leadCategorization = item.lead_categorization;
      const coordinatorFullName = item.coordinator_fullName;
      const budget = item.budget;
      let total = item.total;
      if (total === 'NaN' || isNaN(parseFloat(total))) {
        total = 0;
      }
      const totalValue = total !== null ? total : '0.00';
      let diff = parseFloat(budget) - parseFloat(totalValue);
      if (diff < 0) {
        diff = 0;
      }
      if (!groupedData[leadCategorization]) {
        groupedData[leadCategorization] = {};
        groupedData[leadCategorization][''] = leadCategorization + ' Inquiry Value';
      }
      if (!groupedData[leadCategorization]) {
        groupedData[leadCategorization] = {};
        groupedData[leadCategorization][''] = leadCategorization;
      }
      if (!groupedData[`${leadCategorization} sent`]) {
        groupedData[`${leadCategorization} sent`] = {};
        groupedData[`${leadCategorization} sent`][''] = 'Response Sent';
      }
      if (!groupedData[`${leadCategorization} diff`]) {
        groupedData[`${leadCategorization} diff`] = {};
        groupedData[`${leadCategorization} diff`][''] = 'Response Pending';
      }
      if (!groupedData[leadCategorization][coordinatorFullName]) {
        groupedData[leadCategorization][coordinatorFullName] = budget;
      }
      if (!groupedData[`${leadCategorization} sent`][coordinatorFullName]) {
        groupedData[`${leadCategorization} sent`][coordinatorFullName] = total;
      }
      if (!groupedData[`${leadCategorization} diff`][coordinatorFullName]) {
        groupedData[`${leadCategorization} diff`][coordinatorFullName] = diff.toFixed(2);
      }
    });
    const coordinatorNames = new Set();
    for (const key in groupedData) {
      const group = groupedData[key];
      let hasNonZero = false;
      for (const coordinator in group) {
        coordinatorNames.add(coordinator);
        if (coordinator !== '') {
          var _groupedData, _groupedData2;
          const budgetValue = parseFloat(groupedData[key][coordinator] || '0');
          const sentValue = parseFloat(((_groupedData = groupedData[`${key} sent`]) === null || _groupedData === void 0 ? void 0 : _groupedData[coordinator]) || '0');
          const diffValue = parseFloat(((_groupedData2 = groupedData[`${key} diff`]) === null || _groupedData2 === void 0 ? void 0 : _groupedData2[coordinator]) || '0');
          if (budgetValue !== 0 || sentValue !== 0 || diffValue !== 0) {
            hasNonZero = true;
            break;
          }
        }
      }
      if (hasNonZero) {
        result.push(group);
      }
    }
    this.coordinatorList = this.coordinatorList.filter(coordinator => coordinatorNames.has(coordinator.fullName));
    this.list = result;
  }
  async fetchCoordinatorList() {
    try {
      this.coordinatorList = await (0, _admins.getAdmins)((0, _index.getQuery)({
        enabled: true,
        sort: 'id,ASC',
        filter: {
          enabled: '$eq',
          'adminsRole.name': '$in'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'InquiryValue',
  components: {}
})], default_1);
var _default = exports.default = default_1;